import { Button, Divider, Drawer, Grid, Typography } from '@mui/material';
import { observer } from 'mobx-react';
import { useRootStore } from 'store/StoreContextProvider';
import bluePin from '../../../assets/image/bluePin.png';
import CloseIcon from '../../../assets/image/close.png';
import redPin from '../../../assets/image/redPin.png';
import { useMediaQueryState } from '../../../hooks/useMediaQueryState';
import TimelinePageStore from '../store/TimelinePageStore';

interface TimelineDrawerProps {
  isDrawerVisible: boolean;
  setIsDrawerVisible: (isDrawerVisible: boolean) => void;
  pageStore: TimelinePageStore;
}

function TimelineDrawer(props: TimelineDrawerProps) {
  const { loginStore } = useRootStore();
  const { isPC } = useMediaQueryState();

  const handleClickPeriod = (period: string) => {
    props.pageStore.setFilterValue(period);
  };

  const handleClickBluePin = () => {
    props.pageStore.setFilterLikeUp(!props.pageStore.filterLikeUp);
  };

  const handleClickRedPin = () => {
    props.pageStore.setFilterLikeDown(!props.pageStore.filterLikeDown);
  };

  const handleClickSearch = () => {
    props.pageStore.fetchAsssessListWithPeriod(loginStore.currentUser!.id);
    props.setIsDrawerVisible(false);
  };

  return (
    <Drawer
      anchor={isPC ? 'right' : 'bottom'}
      PaperProps={{
        style: { borderTopLeftRadius: '15px', borderTopRightRadius: '15px' },
      }}
      open={props.isDrawerVisible}
      onClose={() => props.setIsDrawerVisible(false)}
    >
      <Grid>
        <Grid container justifyContent={'center'} alignItems='center' marginBottom={2} style={{ paddingTop: '21px' }}>
          <Typography
            style={{
              fontFamily: 'Pretendard',
              fontStyle: 'normal',
              fontWeight: 600,
              fontSize: '18px',
              lineHeight: '18px',
            }}
          >
            Filter
          </Typography>
          <img src={CloseIcon} style={{ position: 'absolute', right: '18px', top: '18px', cursor: 'pointer' }} onClick={() => props.setIsDrawerVisible(false)} alt='closeIcon' />
        </Grid>
        <Divider style={{ border: '1px solid #dddddd' }} />
        <Typography
          style={{
            fontFamily: 'Pretendard',
            fontStyle: 'normal',
            fontWeight: 600,
            fontSize: '18px',
            lineHeight: '18px',
            paddingTop: '30px',
            paddingLeft: '20px',
          }}
        >
          Period
        </Typography>
        <Grid container marginBottom={2} justifyContent={'space-between'} style={{ padding: '20px 20px 30px 20px' }}>
          <Grid item textAlign={'center'}>
            <Typography
              style={{
                border: props.pageStore.filterValue === 'last30day' ? '1px solid #2281D0' : '1px solid #dddddd',
                borderRadius: '20px',
                fontFamily: 'Pretendard',
                fontStyle: 'normal',
                fontWeight: 500,
                fontSize: '14px',
                lineHeight: '14px',
                padding: '13px 16px',
                width: 90,
                height: 56,
                cursor: 'pointer',
              }}
              onClick={() => handleClickPeriod('last30day')}
            >
              Last 30 days
            </Typography>
          </Grid>
          <Grid item textAlign={'center'}>
            <Typography
              style={{
                border: props.pageStore.filterValue === 'quarter' ? '1px solid #2281D0' : '1px solid #dddddd',
                borderRadius: '20px',
                fontFamily: 'Pretendard',
                fontStyle: 'normal',
                fontWeight: 500,
                fontSize: '14px',
                lineHeight: '14px',
                padding: '20px 16px',
                cursor: 'pointer',
                width: 77,
                height: 56,
              }}
              onClick={() => handleClickPeriod('quarter')}
            >
              Quarter
            </Typography>
          </Grid>
          <Grid item textAlign={'center'}>
            <Typography
              style={{
                border: props.pageStore.filterValue === 'half' ? '1px solid #2281D0' : '1px solid #dddddd',
                borderRadius: '20px',
                fontFamily: 'Pretendard',
                fontStyle: 'normal',
                fontWeight: 500,
                fontSize: '14px',
                lineHeight: '14px',
                padding: '13px 16px',
                cursor: 'pointer',
                width: 77,
                height: 56,
              }}
              onClick={() => handleClickPeriod('half')}
            >
              Half Year
            </Typography>
          </Grid>
          <Grid item textAlign={'center'}>
            <Typography
              style={{
                border: props.pageStore.filterValue === 'year' ? '1px solid #2281D0' : '1px solid #dddddd',
                borderRadius: '20px',
                fontFamily: 'Pretendard',
                fontStyle: 'normal',
                fontWeight: 500,
                fontSize: '14px',
                lineHeight: '14px',
                padding: '13px 16px',
                cursor: 'pointer',
                width: 77,
                height: 56,
              }}
              onClick={() => handleClickPeriod('year')}
            >
              Full Year
            </Typography>
          </Grid>
        </Grid>
        <Grid marginTop={2}>
          <Typography
            style={{
              fontFamily: 'Pretendard',
              fontStyle: 'normal',
              fontWeight: 600,
              fontSize: '18px',
              lineHeight: '18px',
              paddingLeft: '20px',
            }}
          >
            Pin
          </Typography>
          <Grid marginTop={2} container style={{ paddingLeft: '20px' }}>
            <img
              src={bluePin}
              style={{
                padding: '12px',
                border: props.pageStore.filterLikeUp ? '1px solid #2281D0' : '1px solid #dddddd',
                borderRadius: '20px',
                cursor: 'pointer',
              }}
              onClick={handleClickBluePin}
              alt='bluePin'
            />
            <img
              src={redPin}
              style={{
                padding: '12px',
                border: props.pageStore.filterLikeDown ? '1px solid #2281D0' : '1px solid #dddddd',
                borderRadius: '20px',
                marginLeft: '10px',
                cursor: 'pointer',
              }}
              onClick={handleClickRedPin}
              alt='redPin'
            />
          </Grid>
        </Grid>
        <Grid
          container
          marginTop={7.5}
          justifyContent={'center'}
          style={{
            padding: '0 20px 40px 20px',
          }}
        >
          <Button
            variant='contained'
            style={{
              padding: '17px 140px',
              background: '#2281D0',
              borderRadius: '25px',
              fontStyle: 'normal',
              fontWeight: 500,
              fontSize: '16px',
              lineHeight: '16px',
              cursor: 'pointer',
              textTransform: 'unset',
            }}
            onClick={handleClickSearch}
          >
            Search
          </Button>
        </Grid>
      </Grid>
    </Drawer>
  );
}

export default observer(TimelineDrawer);
